import { resetFetched } from "./userData";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export const LOGGED_IN = "LOGGED_IN";
export const LOGGED_OUT = "LOGGED_OUT";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const UNAUTHORIZED = "UNAUTHORIZED";

export const validateThenLogin = tokenProp => async (dispatch, getState) => {
  const { API_ENDPOINT, JWT_COOKIE } = getState().auth;
  let result = {};

  // is the token in the cache?
  const token = tokenProp || cookies.get(JWT_COOKIE) || "";

  try {
    result = await fetch(`${API_ENDPOINT}/loggedin?token=${token}`).then(res =>
      res.json()
    );
  } catch (err) {
    return dispatch({
      type: LOGIN_ERROR,
      payload: err
    });
  }

  if (result.status === 200) {
    dispatch(
      login({ token, userID: result.userID, LoginType: result.LoginType })
    );
  } else {
    dispatch({ type: UNAUTHORIZED });
  }
};

export const login = ({ token, userID, LoginType }) => (dispatch, getState) => {
  // save/replace cookie
  const { JWT_COOKIE } = getState().auth;
  cookies.set(JWT_COOKIE, token);

  dispatch({
    type: LOGGED_IN,
    payload: { token, userID, LoginType }
  });
};

export const logout = () => (dispatch, getState) => {
  // delete cookie
  const { JWT_COOKIE } = getState().auth;
  cookies.remove(JWT_COOKIE);

  // reset fetched data
  dispatch(resetFetched());

  dispatch({
    type: LOGGED_OUT
  });
};
